import { Box } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import InformationCard, { moveCardInterface } from './InformationCard'

function LocationUpdate({
  primary,
  from,
  to,
}: {
  primary: moveCardInterface
  from: moveCardInterface
  to: moveCardInterface
}) {
  return (
    <Box sx={{ minWidth: '500px !important' }}>
      <InformationCard card={primary} />
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
        <InformationCard card={from} />
        <ArrowForward sx={{ mx: 2 }} />
        <InformationCard card={to} />
      </Box>
    </Box>
  )
}

export default LocationUpdate
